import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import Countdown, { zeroPad } from "react-countdown";
import $ from "jquery";
import { toast } from "react-toastify";
import Select from "react-select";
import Web3 from "web3";
import "@metamask/legacy-web3";
import config from "../lib/config";
import Single_ABI from "../ABI/BEP721.json";
import Multiple_ABI from "../ABI/BEP1155.json";
import Single_ABI_coll from "../ABI/collection721.json";
import Multiple_ABI_coll from "../ABI/collection1155.json";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import ConnectWallet from "./separate/Connect-Wallet";
import { connection } from "../helper/connection";
import { ParamAccountAddr_Detail_Get, getCurAddr } from "../actions/v1/user";
import { Helmet } from "react-helmet";

import {
  GetCategoryAction,
  CreateTokenValidationAction,
  CreateCollectionValidationAction,
  TokenAddItemAction,
  TokenAddOwnerAction,
  TokenCount_Get_Action,
  ipfsImageHashGet,
  ipfsmetadatafunciton,
  getwhitelist,
  CollectiblesList_Home,
  Collection_Create,
  Collection_Validate,
  GetCollections,
  addapprove,
  getapprove,
} from "../actions/v1/token";

// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}
toast.configure();
let toasterOption = config.toasterOption;

export default function Create() {
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#ff61ae" : "#101b37",
      };
    },
  };
  var myDate = new Date();
  var newdat = myDate.setDate(myDate.getDate() + parseInt(1));
  var initialEnd = new Date(newdat);
  const [UserAccountAddr, Set_UserAccountAddr] = React.useState("");
  const [AddressUserDetails, Set_AddressUserDetails] = useState({});
  const [Accounts, Set_Accounts] = React.useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [StartDate, Set_StartDate] = useState("Right after listing");
  const [EndDate, Set_EndDate] = useState("1 Day");
  const [Clocktime, set_Clocktime] = useState(new Date());
  const [EndClocktime, set_EndClocktime] = useState(initialEnd);
  const [CategoryOption, setCategoryOption] = useState(0);
  const [collectioncategory, setCollectioncategory] = useState({ label: "" });
  const [collectioncategoryname, setCollectioncategoryname] =
    useState("Select");
  const [currencyName, setcurrencyName] = useState("BNB");
  const [currency, setcurrency] = useState({ label: "" });
  const [contractAddress, setcontractAddress] = useState(config.singleContract);
  const [TokenCategory, setTokenCategory] = useState({ label: "" });
  const [tokenCategory, settokenCategory] = useState("");
  const [TokenFile, setTokenFile] = useState("");
  const [TokenFilePreReader, setTokenFilePreReader] = useState("");
  const [TokenFilePreUrl, setTokenFilePreUrl] = useState("");
  const [PutOnSaleType, setPutOnSaleType] = useState("putonmarket");
  const [DefaultCollection, setDefaultCollection] =
    useState("defaultCollection");
  const [PutOnSale, setPutOnSale] = useState(false);
  const [MinimumBid, Set_MinimumBid] = useState(0);
  const [MaximumBid, Set_MaximumBid] = useState(0);
  const [TokenPrice, setTokenPrice] = useState(0);
  const [Price, setPrice] = useState(0);
  const [YouWillGet, Set_YouWillGet] = useState(0);
  const [TokenName, setTokenName] = useState("");
  const [ValidateError, setValidateError] = useState({ TokenPrice: "" });
  const [tokenWill, setTokenWill] = useState(0);
  const [TokenDescription, setTokenDescription] = useState("");
  const [TokenRoyalities, setTokenRoyalities] = useState(5);
  const [TokenProperties, setTokenProperties] = useState("");
  const [UnLockcontent, Set_UnLockcontent] = useState("");
  const [TokenQuantity, Set_TokenQuantity] = useState(1);
  const [Unlockoncepurchased, Set_Unlockoncepurchased] = useState(false);
  const [FormSubmitUserClicked, Set_FormSubmitUserClicked] = useState(false);
  const [UserAccountBal, Set_UserAccountBal] = useState(0);
  const [ApproveCallStatus, setApproveCallStatus] = useState("init");
  const [MintCallStatus, setMintCallStatus] = useState("init");
  const [SignCallStatus, setSignCallStatus] = useState("init");
  const [SignLockCallStatus, setSignLockCallStatus] = useState("init");
  const [ipfsmetatag, set_ipfsmetatag] = useState("");
  const [ipfshash, setIpfsHash] = useState("");
  const [ipfshashurl, setipfshashurl] = useState("");
  const [TokenCount, Set_TokenCount] = useState(0);
  const [MintHashVal, Set_MintHashVal] = useState("");
  const [whitelistadmin, setWhitelistadmin] = useState("");
  const [useraddress, setUseraddress] = useState("");
  const [CollectiblesType, setCollectiblesType] = useState("Single");
  const [Categoryname, setCategoryname] = useState("Select");
  const [photo, Set_photo] = useState("");
  const [userimage, Set_userimage] = useState("");
  const [owncollectionname, set_owncollectionname] = useState("");
  const [owncollectionsymbol, set_owncollectionsymbol] = useState("");
  const [collectiondescription, set_collectiondescription] = useState("");
  var imageUrl = config.Back_URL + "images/previewThumb.png";
  const [profileimage, setprofileimage] = useState(imageUrl);
  const [collectionurl, set_collectionurl] = useState(
    `${config.Front_URL}/collections/`
  );
  const [WalletConnected, setWalletConnected] = React.useState(false);
  const [showloadercollect, Set_showloadercollect] = useState(false);
  const [CollectibleType, Set_CollectibleType] = useState(721);
  const [ContractAddressUser, set_ContractAddressUser] = React.useState("");
  const [ownsinglecontract, setownsinglecontract] = useState("");
  const [customcollection, setcustomcollection] = React.useState("");
  const [ownmultiplecontract, setownmultiplecontract] = useState("");
  const [mainnet, setmainnet] = React.useState(false);
  const [collectionlist, set_collectionlist] = React.useState(0);
  const [bidprice, set_bidprice] = React.useState(0);
  const [profilestatus, setprofilestatus] = React.useState(false);
  const [putonmarket, setputonmarket] = React.useState(false);
  const [userApproved, setUserApproved] = React.useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [collectionvalidate, setcollectionValidate] = useState({
    collectionname: "",
    collectionsymbol: "",
    url: "",
  });
  const [values, setValues] = useState({ val: [{ des: "", unit: "" }] });

  const [samenamevalid, setsamenamevalid] = useState("");
  const [showcreate, setshowcreate] = useState(false);

  useEffect(() => {
    loadInitialDatas();
  }, []);

  async function loadInitialDatas() {
    await checkconnection();
    await loadScript();
    await GetCategoryCall();
    await getWhitelistAdmin();
    await GetUserCollections("", "");
    await Get_MyItemAccountAddr_Details();
  }
  async function checkconnection() {
    var mydata = await connection();

    if (
      (mydata &&
        mydata.provider &&
        mydata.provider != null &&
        mydata.provider != undefined &&
        mydata.provider != "") ||
      window.ethereum
    ) {
      var provider =
        mydata &&
        mydata.provider &&
        mydata.provider != null &&
        mydata.provider != undefined &&
        mydata.provider
          ? mydata.provider
          : window.ethereum;

      let web3 = new Web3(provider);
      var network = await web3.eth.net.getId();
      if (config.livechainid == network) {
        setshowcreate(true);
      }
    }
  }

  let Collectionsoptions = [];

  const handleFilecollection = (event) => {
    event.preventDefault();
    const { id, files } = event.target;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      var url = reader.readAsDataURL(event.target.files[0]);
      var file = event.target.files[0];
      var validExtensions = ["jpg", "png", "gif", "jpeg"];
      if (file && file.name) {
        var fileName = file.name;
        var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        if ($.inArray(fileNameExt, validExtensions) === -1) {
          toast.error(
            "Only these file types are accepted : " +
              validExtensions.join(", "),
            toasterOption
          );
          return false;
        } else {
          Set_photo(file);
          reader.onloadend = function (e) {
            Set_userimage(reader.result);
          }.bind(this);
        }
      } else {
        toast.error(
          "Only these file types are accepted : " + validExtensions.join(", "),
          toasterOption
        );
      }
    }
  };

  async function GetUserCollections(currAddr, type) {
    setCollectioncategoryname("Select");
    set_collectionlist("");
    var newType = type == "" ? CollectibleType : type;
    //var web3 = new Web3(window.ethereum);
    var mydata = await connection();
    const web3 = new Web3(
      mydata &&
      mydata.provider &&
      mydata.provider != null &&
      mydata.provider != undefined &&
      mydata.provider != ""
        ? mydata.provider
        : window.ethereum
    );
    const getaccounts = await web3.eth.getAccounts();
    if (
      getaccounts &&
      getaccounts[0] &&
      getaccounts[0] != null &&
      getaccounts[0] != undefined &&
      getaccounts[0] != ""
    ) {
      currAddr = getaccounts[0].toLowerCase();

      Collectionsoptions = [];
      var response = await GetCollections({
        useraddress: currAddr,
        type: newType,
        contractadd: ContractAddressUser,
      });
      if (
        response &&
        response.data &&
        response.data.RespData &&
        response.data.RespData.length > 0
      ) {
        var collectionarray = response.data.RespData;
        if (collectionarray.length > 0) {
          for (let i = 0; i < collectionarray.length; i++) {
            var datas = {
              name: "collectioncategory",
              value: collectionarray[i].conAddr,
              label: collectionarray[i].symbol,
            };
            Collectionsoptions.push(datas);
          }

          set_collectionlist(Collectionsoptions);
        } else {
          var datas = {
            value: "No Record",
            name: "collectioncategory",
            label: "No Record",
          };
          Collectionsoptions.push(datas);
          set_collectionlist(Collectionsoptions);
        }
      } else {
        var datas = {
          value: "No Record",
          name: "collectioncategory",
          label: "No Record",
        };
        Collectionsoptions.push(datas);
        set_collectionlist(Collectionsoptions);
      }
    }
  }

  const inputChangename = async (e) => {
    set_owncollectionname(e.target.value);
  };

  const inputChangesymbol = async (e) => {
    set_owncollectionsymbol(e.target.value);
  };

  const inputChangedescription = async (e) => {
    set_collectiondescription(e.target.value);
  };

  const inputChangeurl = async (e) => {
    set_collectionurl(e.target.value);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    //if (window.ethereum) {
    //var web3 = new Web3(window.ethereum);

    var mydata = await connection();
    const web3 = new Web3(
      mydata &&
      mydata.provider &&
      mydata.provider != null &&
      mydata.provider != undefined &&
      mydata.provider != ""
        ? mydata.provider
        : window.ethereum
    );

    try {
      if (
        typeof web3 !== "undefined" &&
        web3 != null &&
        web3 != undefined &&
        web3 != ""
      ) {
        setWalletConnected(true);

        var result = await web3.eth.getAccounts();
        if (result && result != null && result != undefined && result != "") {
          setUseraddress(result[0].toLowerCase());
          var currAddr = result[0].toLowerCase();
          Set_showloadercollect(true);
          if (owncollectionname == "" || owncollectionname.trim().length == 0) {
            toast.error("Please Enter the Collection Name", toasterOption);
            Set_showloadercollect(false);
            return false;
          }

          if (
            owncollectionsymbol == "" ||
            owncollectionsymbol.trim().length == 0
          ) {
            toast.error("Please Enter the Collection Symbol", toasterOption);
            Set_showloadercollect(false);
            return false;
          }

          if (photo == null || photo == "" || photo == undefined) {
            toast.error("Please Choose the Collection Image", toasterOption);
            Set_showloadercollect(false);
            return false;
          }

          var validExtensions = [
            "jpg",
            "png",
            "gif",
            "webp",
            "mp4",
            "mp3",
            "jpeg",
            "svg",
            // "mpeg",
            // "avi",
            "wav",
          ];
          if (photo && photo.name) {
            var fileName = photo.name;
            var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
            if ($.inArray(fileNameExt, validExtensions) === -1) {
              toast.error(
                "Only these file types are accepted : " +
                  validExtensions.join(", "),
                toasterOption
              );
              return false;
            }
          }

          if (
            collectionurl.replace(`${config.Front_URL}/collections/`, "") == ""
          ) {
            toast.error("Please Enter the Collection Url", toasterOption);
            Set_showloadercollect(false);
            return false;
          }

          let validpayload = {
            collectionname: owncollectionname,
            collectionsymbol: owncollectionsymbol,
            url: collectionurl.replace(`${config.Front_URL}/collections/`, ""),
          };
          let { error, status } = await Collection_Validate(validpayload);
          if (error) {
            toast.error("Your entered details already used", toasterOption);
            setcollectionValidate(error.errors);
            Set_showloadercollect(false);
            return false;
          }
          var jsonabi = "";
          var byteCode = "";
          let payload = "";
          if (CollectibleType == 721) {
            jsonabi = Single_ABI_coll;
            byteCode =
              "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";
            payload = {
              arguments: [
                1,
                currAddr,
                config.singleContract,
                config.tokenSymbol,
                config.tokenAddress,
                owncollectionname,
                owncollectionsymbol,
              ],
            };
          } else if (CollectibleType == 1155) {
            jsonabi = Multiple_ABI_coll;
            byteCode =
              "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";
            payload = {
              arguments: [
                1,
                currAddr,
                config.multipleContract,
                config.tokenSymbol,
                config.tokenAddress,
                owncollectionname,
                owncollectionsymbol,
              ],
            };
          }
          var servicefee = config.fee;
          var randomtokenid = Math.floor(Date.now() / 1000);
          try {
            var mychoice = localStorage.getItem("choice");
            var deploy_contract = await new web3.eth.Contract(jsonabi);
            deploy_contract.options.data = "0x" + byteCode;
            let account = currAddr;
            let type = config.tokenname;
            var tokenadd = config.WMATICaddress;
            let parameter = {
              from: account,
            };
            // let payload = {
            //   arguments: [1, servicefee.toString(), currAddr],
            // };

            deploy_contract
              .deploy(payload)
              .send(parameter, (err, transactionHash) => {})
              .on("confirmation", () => {})
              .then(async (newContractInstance) => {
                var bep20 = newContractInstance.options.address;
                set_ContractAddressUser(bep20);
                if (CollectibleType == 721) {
                  setownsinglecontract(bep20);
                  //  var newnftsingle = new web3.eth.Contract(singleabi,bep20);
                  //  var fee1 = parseFloat(singlefee)*1000000000000000000
                  //  var restt = await newnftsingle.methods.serviceFunction(fee1.toString()).send({
                  //    from: result[0]
                  //  });
                  // var token = "["+config.tokenname+"]"
                  //  var restt = await newnftsingle.methods.addTokenType(token.toString(),config.WMATICaddress).send({
                  //    from: result[0]
                  //  });
                  var payload = {
                    useraddress: currAddr,
                    newcontract: bep20,
                    collectionname: owncollectionname,
                    collectionsymbol: owncollectionsymbol,
                    collectiondescription: collectiondescription,
                    imageUser: photo,
                    type: CollectibleType,
                    url: collectionurl.replace(
                      `${config.Front_URL}/collections/`,
                      ""
                    ),
                  };

                  var collectionresp = await Collection_Create(payload);
                  if (collectionresp.data.status) {
                    setcustomcollection(bep20);
                    Set_showloadercollect(false);
                    window.$("#choose_collection_modal").modal("hide");
                    GetUserCollections(currAddr, "");
                    toast.success("Collection created", toasterOption);
                    window.location.reload();
                  } else {
                    Set_showloadercollect(false);
                    toast.error("error", "Server Error", toasterOption);
                  }
                } else {
                  setownmultiplecontract(bep20);
                  //  var fee1 = parseFloat(multiplefee)*1000000000000000000
                  //  var newnftsingle = new web3.eth.Contract(multipleabi,bep20);
                  //  var restt = await newnftsingle.methods.serviceFunction(fee1.toString()).send({
                  //    from: result[0]
                  //  });
                  // var token = "["+config.tokenname+"]"
                  //  var restt = await newnftsingle.methods.addTokenType(token.toString(),config.WMATICaddress).send({
                  //    from: result[0]
                  //  });
                  var payload = {
                    useraddress: currAddr,
                    newcontract: bep20,
                    collectionname: owncollectionname,
                    collectionsymbol: owncollectionsymbol,
                    collectiondescription: collectiondescription,
                    imageUser: photo,
                    type: CollectibleType,
                    url: collectionurl.replace(
                      `${config.Front_URL}/collections/`,
                      ""
                    ),
                  };

                  var collectionresp = await Collection_Create(payload);
                  if (collectionresp.data.status) {
                    setcustomcollection(bep20);
                    Set_showloadercollect(false);
                    window.$("#choose_collection_modal").modal("hide");
                    GetUserCollections(currAddr, "");
                    toast.success("Collection created", toasterOption);
                    window.location.reload();
                  } else {
                    Set_showloadercollect(false);
                    toast.error("Server Error", toasterOption);
                  }
                }
              })
              .catch((err) => {
                Set_showloadercollect(false);
                toast.error("User Rejected", toasterOption);
              });
          } catch (err) {
            Set_showloadercollect(false);
            toast.error("User Rejected", toasterOption);
          }
          // } else {
          //   Set_showloadercollect(false);
          //   toast.error("Please Choose Mainnet", toasterOption);
          // }
          //} else {
          // Set_showloadercollect(false)
          // toast.error("Please Choose Mainnet", toasterOption);
          //}
          //}
          //})
          // .catch((e) => {});
        } else {
          setWalletConnected(false);
          setmainnet(false);
          toast.error("Please add Metamask plugin", toasterOption);
        }
      } else {
        setWalletConnected(false);
        setmainnet(false);
        toast.error("Please add Metamask plugin", toasterOption);
      }
    } catch (err) {
      setmainnet(false);
      setWalletConnected(false);
    }
    //}
  };

  const addClick = () => {
    setValues({ val: [...values.val, { des: "", unit: "" }] });
  };

  function loadScript() {
    dropdown("#item_category");
    dropdown("#price_catagory");
    dropdown("#item_category_multiple1");
    dropdown("#buy_category");
    dropdown("#item_collection");
    dropdown("#item_category_multiple1");

    function dropdown(e) {
      var obj = $(e + ".dropdown");
      var btn = obj.find(".btn-selector");
      var dd = obj.find("ul");
      var opt = dd.find("li");

      obj
        .on("click", function () {
          dd.show();
        })
        .on("mouseleave", function () {
          dd.hide();
        });

      opt.on("click", function () {
        dd.hide();
        var txt = $(this).text();
        opt.removeClass("active");
        $(this).addClass("active");
        btn.text(txt);
      });
    }
  }

  async function DateChange(from, val) {
    if (from == "StartDateDropDown") {
      if (val == "PickStartDate") {
        ModalAction("calendar_modal", "show");
      } else {
        Set_StartDate("Right after listing");
      }
    } else if (from == "EndDateDropDown") {
      if (val == "PickEndDate") {
        ModalAction("calendar_modal_expire", "show");
      } else {
        Set_EndDate(val);
        var myDate = new Date();
        var newdat = myDate.setDate(myDate.getDate() + parseInt(val));
        var newdate = new Date(newdat);
        set_EndClocktime(newdate);
      }
    }
  }

  async function ModalAction(id, type) {
    window.$("#" + id).modal(type);
    if (id == "calendar_modal") {
      if (Clocktime) {
        var dt = new Date(Clocktime);
        dt.setSeconds(0);
        var dt1 = dt.toLocaleString();
        Set_StartDate(dt1);
      }
    } else if (id == "calendar_modal_expire") {
      if (EndClocktime) {
        var dt = new Date(EndClocktime);
        dt.setSeconds(0);
        var dt1 = dt.toLocaleString();
        Set_EndDate(dt1);
      }
    }
  }

  async function GetCategoryCall() {
    var resp = await GetCategoryAction();
    if (resp && resp.data && resp.data.list) {
      var CategoryOption = [];
      resp.data.list.map((item) => {
        CategoryOption.push({
          name: "TokenCategory",
          value: item._id,
          label: item.category,
        });
      });
      setCategoryOption(CategoryOption);
    }
  }
  async function getWhitelistAdmin() {
    try {
      var mydata = await connection();
      const web3 = new Web3(
        mydata &&
        mydata.provider &&
        mydata.provider != null &&
        mydata.provider != undefined &&
        mydata.provider != ""
          ? mydata.provider
          : window.ethereum
      );

      // const getaccounts = await web3.eth.getAccounts();
      var getaccounts = await web3.eth.getAccounts();
      if (
        getaccounts != undefined &&
        getaccounts != null &&
        getaccounts != ""
      ) {
        var payload = {
          address: getaccounts[0].toLowerCase(),
        };
        setUseraddress(getaccounts[0].toLowerCase());
        const resp = await getwhitelist(payload);
        if (resp && resp.data) {
          if (resp.data.data != null) {
            setWhitelistadmin(resp.data.data.address);
            if (resp.data.data.address == getaccounts[0].toLowerCase()) {
              var bidpriceset = [
                { value: config.currencySymbol, label: config.currencySymbol },
                { value: config.owntokenSymbol, label: config.owntokenSymbol },
              ];
              set_bidprice(bidpriceset);
            } else {
              var bidpriceset = [
                { value: config.currencySymbol, label: config.currencySymbol },
              ];
              set_bidprice(bidpriceset);
            }
          } else {
            var bidpriceset = [
              { value: config.currencySymbol, label: config.currencySymbol },
            ];
            set_bidprice(bidpriceset);
            setWhitelistadmin("");
          }
        }
      }
    } catch (err) {}
  }
  function changeCategory(eve) {
    setTokenCategory(eve.label);
    setCategoryname(eve.label);
  }

  function changeCurrency(eve) {
    setcurrencyName(eve.value);
    setcurrency(eve.value);
  }

  async function approvestatus() {
    var currAddr = await getCurAddr();
    if (typeof currAddr != "undefined") {
      var selectedcontract =
        CollectiblesType == "Single"
          ? config.singleContract
          : config.multipleContract;

      if (contractAddress && contractAddress != "") {
        var selectedcontract = contractAddress;
      }
      let data = {
        address: currAddr,
        contractaddress: selectedcontract,
      };
      var Resp = await getapprove(data);
      if (
        Resp &&
        Resp.data &&
        Resp.data.data &&
        Resp.data.data.data &&
        Resp.data.data.data.contractaddress &&
        Resp.data.data.data.contractaddress == selectedcontract
      ) {
        setUserApproved(true);
        setApproveCallStatus("done");
      } else {
        setUserApproved(false);
        // alert("rejetc")
      }
    }
  }

  async function Get_MyItemAccountAddr_Details() {
    var currAddr = await getCurAddr();
    if (typeof currAddr != "undefined") {
      let data = {
        addr: currAddr,
      };
      var Resp = await ParamAccountAddr_Detail_Get(data);
      if (Resp && Resp.data && Resp.data.User && Resp.data.User.curraddress) {
        if (Resp.data.User) {
          if (
            Resp.data.User.image &&
            Resp.data.User.image != null &&
            Resp.data.User.image != undefined &&
            Resp.data.User.image != ""
          ) {
            setprofileimage(
              config.Back_URL + "profile/" + Resp.data.User.image
            );
          }
          setprofilestatus(Resp.data.User.isverified);
        }
      } else {
      }
    }
  }

  function changecollectionCategory(ev) {
    if (ev.label != "No Record") {
      setCollectioncategory(ev.label);
      setCollectioncategoryname(ev.label);
      setcontractAddress(ev.value);
      setDefaultCollection("");
      setSelectedOption(ev);

      var bidpriceset = [
        { value: config.currencySymbol, label: config.currencySymbol },
      ];
      set_bidprice(bidpriceset);
      setcurrencyName("BNB");
    } else {
      setPrice(0);
      setDefaultCollection("defaultCollection");
      setCollectioncategory({ label: "" });
      setCollectioncategoryname("Select");
      setcontractAddress(
        CollectiblesType == "Single"
          ? config.singleContract
          : config.multipleContract
      );
    }
  }
  const selectFileChange = (e) => {
    var validExtensions = [
      "jpg",
      "png",
      "gif",
      "webp",
      "mp4",
      "mp3",
      "jpeg",
      "svg",
      // "mpeg",
      // "avi",
      // "mav",
      "wav",
    ]; //array of valid extensions
    if (e.target && e.target.files) {
      var reader = new FileReader();
      var file = e.target.files[0];
      var fileName = file.name;
      var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
      if ($.inArray(fileNameExt, validExtensions) == -1) {
        toast.error(
          "Only these file types are accepted : " + validExtensions.join(", "),
          toasterOption
        );
        $("input[name='image']").val("");
        return false;
      } else {
        const fileSize = file.size / 1024 / 1024;
        if (fileSize > 100) {
          toast.error("File size exceeds 100 MB", toasterOption);
          $("input[name='image']").val("");
          return false;
        } else {
          setTokenFile(file);
          var url = reader.readAsDataURL(file);
          reader.onloadend = function (e) {
            if (reader.result) {
              setTokenFilePreReader(reader.result);
            }
          }.bind(this);
          setTokenFilePreUrl(e.target.value);
          toast.success("File Uploaded Successfully", toasterOption);
        }
      }
    }
  };
  const changePutOnSaleType = (type) => {
    setPutOnSaleType(type);
    if (type == "FixedPrice") {
      Set_MinimumBid("");
    } else if ((type = "TimedAuction")) {
      setTokenPrice("");
      setPrice(0);
    } else {
      Set_MinimumBid("");
      setTokenPrice("");
      setPrice(0);
    }
  };

  const changeDefaultCollection = (type) => {
    setPrice(0);
    setDefaultCollection(type);
    setCollectioncategory({ label: "" });
    setCollectioncategoryname("Select");
    setcontractAddress(
      CollectiblesType == "Single"
        ? config.singleContract
        : config.multipleContract
    );
  };

  const changeCollectiblesType = async (type) => {
    setSelectedOption(null);
    setCollectiblesType(type);
    Set_CollectibleType(type == "Single" ? 721 : 1155);
    await GetUserCollections("", type == "Single" ? 721 : 1155);

    setcontractAddress(
      type == "Single" ? config.singleContract : config.multipleContract
    );
    await changePutOnSaleType("FixedPrice");
  };

  const PriceCalculate = async (data = {}) => {
    try {
      //var provider = window.ethereum;
      //var web3 = new Web3(provider);
      var mydata = await connection();
      const web3 = new Web3(
        mydata &&
        mydata.provider &&
        mydata.provider != null &&
        mydata.provider != undefined &&
        mydata.provider != ""
          ? mydata.provider
          : window.ethereum
      );

      var price = typeof data.price != "undefined" ? data.price : TokenPrice;
      var weii = await web3.utils.toWei(price.toString());
      var nftContract = new web3.eth.Contract(
        Single_ABI,
        config.singleContract
      );
      var fee = await nftContract.methods.getServiceFee().call();
      var per = (weii * fee) / 1e20;
      var mulWei = parseFloat(weii - per);
      Set_YouWillGet((mulWei / config.decimalvalues).toFixed(config.toFixed));
      setTokenWill((mulWei / config.decimalvalues).toFixed(config.toFixed));
    } catch (err) {}
  };
  const CheckedChange = (e) => {
    if (e && e.target && e.target.name) {
      if (e.target.name == "putonsale") {
        if (PutOnSale == false) {
          setputonmarket(true);
          setPutOnSale(true);
          if (PutOnSaleType == "" || PutOnSaleType == "putonmarket") {
            setPutOnSaleType("FixedPrice");
          }
          setPrice(0);
        } else {
          setputonmarket(false);
          setPutOnSale(false);
        }
      } else if (e.target.name == "unlockoncepurchased") {
        if (Unlockoncepurchased == false) {
          Set_Unlockoncepurchased(true);
        } else {
          Set_Unlockoncepurchased(false);
        }
      }
    }
  };
  const inputChange = async (e) => {
    if (
      e &&
      e.target &&
      typeof e.target.value != "undefined" &&
      e.target.name
    ) {
      var value = e.target.value;
      switch (e.target.name) {
        case "TokenPrice":
          if (value != "" && isNaN(value) == false && value > 0) {
            setTokenPrice(value);
            PriceCalculate({ price: value });
            ValidateError.TokenPrice = "";
            setValidateError(ValidateError);
          } else {
            ValidateError.TokenPrice = "Enter Valid price";
            setValidateError(ValidateError);
            setTokenPrice("0");
            PriceCalculate({ price: 0 });
          }
          break;
        case "Price":
          if (value != "" && isNaN(value) == false) {
            setPrice(value);
            PriceCalculate({ price: value });
            ValidateError.Price = "";
            setValidateError(ValidateError);
          } else {
            ValidateError.Price = "Enter Valid price";
            setValidateError(ValidateError);
            setPrice();
            PriceCalculate({ price: 0 });
          }
          break;
        case "TokenName":
          setTokenName(value);
          break;
        case "TokenDescription":
          setTokenDescription(value);
          break;
        case "TokenRoyalities":
          setTokenRoyalities(value);
          break;
        case "TokenProperties":
          setTokenProperties(value);
          break;
        case "UnLockcontent":
          Set_UnLockcontent(value);
          break;
        case "MinimumBid":
          Set_MinimumBid(value);
          break;
        case "MaximumBid":
          Set_MaximumBid(value);
          break;
        case "TokenQuantity":
          Set_TokenQuantity(value);
          break;
        default:
      }
    }
  };

  async function CreateItemValidation(chk) {
    if (chk) {
      var ValidateError = {};

      if (PutOnSaleType == "TimedAuction" && putonmarket) {
        var currDate = new Date();
        var sDate = new Date(Clocktime);
        if (StartDate == "Right after listing") {
          set_Clocktime(currDate);
          sDate = currDate;
        }

        var startDate = new Date(Clocktime);
        var eDate = new Date(EndClocktime);
        startDate.setSeconds(0);
        eDate.setSeconds(0);
        if (new Date(currDate) > new Date(sDate)) {
          ValidateError.StartDate =
            "Start date & Time must be greater than now";
        }

        if (Date.parse(startDate) >= Date.parse(eDate)) {
          ValidateError.EndDate =
            '"End date" & Time must be greater than start date and Time';
        }
      }

      //SameTitleNotAllowed
      var valinamepay = {
        name: TokenName,
      };
      var nameer = await CreateTokenValidationAction(valinamepay);
      var namealreadyexi = nameer.data.errors.TokenName;
      if (namealreadyexi == "Name Exits") {
        ValidateError.TokenName = '"Title" already exits';
      }
      //SameTitleNotAllowed

      if (TokenName == "") {
        ValidateError.TokenName = '"Title" is not allowed to be empty';
      }
      if (TokenName.trim().length == 0) {
        ValidateError.TokenName = '"Title" is not allowed to be empty';
      }

      function isValidString(email) {
        return /[^a-zA-Z0-9& ]/g.test(email);
      }

      if (isValidString(TokenName)) {
        ValidateError.TokenName = '"Title" Special character not allowed';
      }

      if (TokenRoyalities == "") {
        ValidateError.TokenRoyalities = '"Royalty" is not allowed to be empty';
      } else if (isNaN(TokenRoyalities) == true) {
        ValidateError.TokenRoyalities = '"Royalty" must be a number';
      } else if (TokenRoyalities > 40) {
        ValidateError.TokenRoyalities =
          '"Royalty" must be less than or equal to 40';
      } else if (TokenRoyalities == 0) {
        ValidateError.TokenRoyalities = '"Royalty" must be grater than to 0';
      }

      if (TokenFilePreUrl == "") {
        ValidateError.TokenFilePreUrl = '"File" is required';
      }

      if (Unlockoncepurchased && UnLockcontent == "") {
        ValidateError.UnLockcontent = '"Locked content" is required';
      }

      if (PutOnSaleType == "FixedPrice" && putonmarket) {
        if (isNaN(Price) == true) {
          // ValidateError.Price = '"Price" must be a number';
          ValidateError.Price = '"Price" amount is required"';
        }
        if (Price == 0 || parseFloat(Price) < 0) {
          ValidateError.Price = '"Price" must be greater than zero';
        }
        if (Price == "") {
          ValidateError.Price = '"Price" amount is required"';
        }
        if (Price == 0) {
          ValidateError.Price = '"Price" must be greater than zero';
        }
      }

      if (PutOnSaleType == "TimedAuction" && putonmarket) {
        const regex = new RegExp(`^\\d*\\.?\\d{0,${8}}$`);

        if (parseFloat(MinimumBid) <= 0) {
          // ValidateError.MinimumBid = '"Minimum Bid" must be a number';
          ValidateError.MinimumBid = 'Enter Valid "Minimum Bid"';
        }
        if (parseFloat(MaximumBid) <= 0) {
          // ValidateError.MaximumBid = '"Maximum Bid" must be a number';
          ValidateError.MaximumBid = 'Enter Valid "Maximum Bid"';
        }
        if (parseFloat(MaximumBid) < parseFloat(MinimumBid)) {
          ValidateError.MaximumBid =
            '"Maximum Bid" must be Greater than Minimum Bid';
        }
        if (MinimumBid == "") {
          ValidateError.MinimumBid = "Minimum bid amount is required";
        }
        if (MaximumBid == "") {
          ValidateError.MaximumBid = "Maximum bid amount is required";
        }
        if (!regex.test(MinimumBid)) {
          ValidateError.MinimumBid =
            "Decimal value must be less than or equal to 8";
        }
        if (!regex.test(MaximumBid)) {
          ValidateError.MaximumBid =
            "Decimal value must be less than or equal to 8";
        }
      }

      if (
        typeof TokenCategory == "undefined" ||
        TokenCategory == "" ||
        TokenCategory.label == ""
      ) {
        ValidateError.TokenCategory = '"Category" is required';
      }

      if (TokenQuantity == "" || isNaN(TokenQuantity) == true) {
        ValidateError.TokenQuantity =
          '"Number of copies" must be a number & greater than zero';
      } else if (TokenQuantity == 0) {
        ValidateError.TokenQuantity =
          '"Number of copies" must be greater than zero';
      }

      if (
        Unlockoncepurchased == true &&
        UnLockcontent != null &&
        UnLockcontent != undefined &&
        UnLockcontent != ""
      ) {
      } else if (Unlockoncepurchased == true) {
        ValidateError.UnLockcontent = "Unlock content must be a Valid one";
      }
      setValidateError(ValidateError);
      return ValidateError;
    } else {
      return {};
    }
  }


  async function CreateItem() {
    Set_FormSubmitUserClicked(true);
    var connectwallet = localStorage.getItem("OmniedenMetamask");
    if (!connectwallet) {
      toast.error("Please connect to a Metamask wallet", toasterOption);
      return false;
    }
    var errors = await CreateItemValidation(true);
    var errorsSize = Object.keys(errors).length;

    // var valinamepay = {
    //   name:TokenName
    // }
    // var nameer = await CreateTokenValidationAction(valinamepay)
    // setsamenamevalid(nameer.data.errors)

    if (errorsSize != 0) {
      toast.error(
        "Form validation error, please fill all the required fields",
        toasterOption
      );
      return false;
    } else {
      await approvestatus();
      var mydata = await connection();
      const web3 = new Web3(
        mydata &&
        mydata.provider &&
        mydata.provider != null &&
        mydata.provider != undefined &&
        mydata.provider != ""
          ? mydata.provider
          : window.ethereum
      );

      if (
        typeof web3 == "undefined" ||
        web3 == null ||
        web3 == undefined ||
        web3 == ""
      ) {
        toast.error("Please Connect to Binance Network", toasterOption);
        return false;
      } else {
        var currAddr = await web3.eth.getAccounts();
        if (
          currAddr &&
          currAddr != null &&
          currAddr != undefined &&
          currAddr[0] &&
          currAddr != null &&
          currAddr != undefined &&
          currAddr[0] &&
          currAddr[0] != null &&
          currAddr[0] != undefined &&
          currAddr[0] != ""
        ) {
          web3.eth.getBalance(
            currAddr[0].toLowerCase(),
            async (errors, balance) => {
              var usercurbal = 0;
              if (typeof balance == "undefined" || balance == null) {
                Set_UserAccountBal(0);
              } else {
                usercurbal = balance / config.decimalvalues;
                Set_UserAccountBal(usercurbal);
              }
              if (usercurbal == 0) {
                toast.error("Insufficient balance", toasterOption);
                return false;
              }
              var TokenCategory_label = TokenCategory;

              let payload = {
                TokenName,
                TokenRoyalities,
                image: TokenFile,
                TokenCategory_label,
                PutOnSaleType,
                TokenPrice,
              };
              window.$("#create_item_modal").modal("show");
            }
          );
        } else {
          toast.warning("OOPS!..connect Your Wallet", toasterOption);
        }
      }
    }
  }
  async function ApproveCall() {
    // if (!window.ethereum) {
    //   toast.warning("OOPS!..connect Your Wallet", toasterOption);
    //   return false;
    // }
    setApproveCallStatus("processing");

    var mydata = await connection();
    const web3 = new Web3(
      mydata &&
      mydata.provider &&
      mydata.provider != null &&
      mydata.provider != undefined &&
      mydata.provider != ""
        ? mydata.provider
        : window.ethereum
    );
    var currAddr = await web3.eth.getAccounts();

    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }

    var singleContract = new web3.eth.Contract(
      Single_ABI,
      config.singleContract
    );

    var multipleContract = new web3.eth.Contract(
      Multiple_ABI,
      config.multipleContract
    );

    var selectedcontract =
      CollectiblesType == "Single"
        ? config.singleContract
        : config.multipleContract;

    if (contractAddress && contractAddress != "") {
      if (CollectiblesType == "Single") {
        var CoursetroContract = new web3.eth.Contract(
          Single_ABI,
          contractAddress
        );
      } else {
        var CoursetroContract = new web3.eth.Contract(
          Multiple_ABI,
          contractAddress
        );
      }
      var selectedcontract = contractAddress;
    } else {
      var CoursetroContract =
        CollectiblesType == "Single" ? singleContract : multipleContract;
    }

    setApproveCallStatus("processing");

    if (userApproved == false) {
      await CoursetroContract.methods
        .setApproval(selectedcontract, true)
        .send({
          from: currAddr[0].toLowerCase(),
        })
        .then(async (result) => {
          var datass = {
            address: currAddr[0].toLowerCase(),
            contractaddress: selectedcontract,
          };
          var restu = await addapprove(datass);
          toast.success("Wallet authorized", toasterOption);
          // setApproveCallStatus("done");
        })
        .catch((error) => {
          toast.error("Wallet authorization failed", toasterOption);
          setApproveCallStatus("tryagain");
        });
    }
    var unix = Math.round(new Date() / 1000);
    let ran = Math.floor(Math.random() * 100 + 1);
    let tokenid = unix + ran;

    Set_TokenCount(tokenid);
    var senddata = {
      Image: TokenFile,
      tokenid: tokenid,
      TokenName: TokenName,
    };
    var ipfsimghashget = await ipfsImageHashGet(senddata);
    if (ipfsimghashget.data !== undefined) {
      if (ipfsimghashget.data.ipfsval != "") {
        setIpfsHash(ipfsimghashget.data.ipfsval);
        setipfshashurl(`${config.IPFS_IMG}/${ipfsimghashget.data.ipfsval}`);
      }
      var newobj = {
        name: TokenName,
        tokenId: tokenid,
        image: config.IPFS_IMG + "/" + ipfsimghashget.data.ipfsval,
      };

      var ipfsmetatagVal = await ipfsmetadatafunciton(newobj);

      if (ipfsmetatagVal.data !== undefined) {
        if (ipfsmetatagVal.data.ipfsval != "") {
          var ipfsurl = ipfsmetatagVal.data.ipfsval;
          set_ipfsmetatag(`${config.IPFS_IMG}/${ipfsurl}`);
        }
      }
    }

    // toast.success("Wallet authorized", toasterOption);
    setApproveCallStatus("done");
  }

  async function againapprovecall() {
    var unix = Math.round(new Date() / 1000);
    let ran = Math.floor(Math.random() * 100 + 1);
    let tokenid = unix + ran;

    Set_TokenCount(tokenid);

    return tokenid;
  }

  function convert(n) {
    var sign = +n < 0 ? "-" : "",
      toStr = n.toString();
    if (!/e/i.test(toStr)) {
      return n;
    }
    var [lead, decimal, pow] = n
      .toString()
      .replace(/^-/, "")
      .replace(/^([0-9]+)(e.*)/, "$1.$2")
      .split(/e|\./);
    return +pow < 0
      ? sign +
          "0." +
          "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) +
          lead +
          decimal
      : sign +
          lead +
          (+pow >= decimal.length
            ? decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))
            : decimal.slice(0, +pow) + "." + decimal.slice(+pow));
  }

  async function ChecktokenDecimal(amount, decimals) {
    var result = 0;
    var decimalsLength = 18;
    if (decimals && decimals > 0) {
      decimalsLength = decimals;
    }
    try {
      var number = amount.toString();
      var number1 = number.split(".");
      if (number1[1] && number1[1].length && number1[1].length > 0) {
        result = number1[0];
      } else {
        result = amount;
      }
      return result;
    } catch (err) {
      return result;
    }
  }

  async function MintCall() {
    let ipfs_hash = ipfshash;
    let ipfs_url = ipfsmetatag;
    // if (!window.ethereum) {
    //   toast.warning("OOPS!..connect Your Wallet", toasterOption);
    //   return false;
    // }
    var mydata = await connection();
    const web3 = new Web3(
      mydata &&
      mydata.provider &&
      mydata.provider != null &&
      mydata.provider != undefined &&
      mydata.provider != ""
        ? mydata.provider
        : window.ethereum
    );
    var currAddr = await web3.eth.getAccounts();

    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }

    setMintCallStatus("processing");
    var tokeid = "";
    if (userApproved == true) {
      tokeid = await againapprovecall();
      Set_TokenCount(tokeid);
      var senddata = {
        Image: TokenFile,
        tokenid: tokeid,
        TokenName: TokenName,
      };
      // var tokendatas = {
      //   tokenid: tokeid,
      //   TokenName: TokenName,
      // }
      var ipfsimghashget = await ipfsImageHashGet(senddata);
      if (ipfsimghashget.data !== undefined) {
        if (ipfsimghashget.data.ipfsval != "") {
          setIpfsHash(ipfsimghashget.data.ipfsval);
          ipfs_hash = ipfsimghashget.data.ipfsval;
          setipfshashurl(`${config.IPFS_IMG}/${ipfsimghashget.data.ipfsval}`);
        }
        var newobj = {
          name: TokenName,
          tokenId: tokeid,
          image: config.IPFS_IMG + "/" + ipfsimghashget.data.ipfsval,
        };

        var ipfsmetatagVal = await ipfsmetadatafunciton(newobj);

        if (ipfsmetatagVal.data !== undefined) {
          if (ipfsmetatagVal.data.ipfsval != "") {
            var ipfsurl = ipfsmetatagVal.data.ipfsval;
            set_ipfsmetatag(`${config.IPFS_IMG}/${ipfsurl}`);
            ipfs_url = config.IPFS_IMG + "/" + ipfsurl;
          }
        }
      }
    } else {
      tokeid = TokenCount;
    }
    var singleContract = new web3.eth.Contract(
      Single_ABI,
      config.singleContract
    );
    var multipleContract = new web3.eth.Contract(
      Multiple_ABI,
      config.multipleContract
    );
    var selectedcontract =
      CollectiblesType == "Single"
        ? config.singleContract
        : config.multipleContract;
    if (contractAddress && contractAddress != "") {
      if (CollectiblesType == "Single") {
        var CoursetroContract = new web3.eth.Contract(
          Single_ABI,
          contractAddress
        );
      } else {
        var CoursetroContract = new web3.eth.Contract(
          Multiple_ABI,
          contractAddress
        );
      }
      var selectedcontract = contractAddress;
    } else {
      var CoursetroContract =
        CollectiblesType == "Single" ? singleContract : multipleContract;
    }

    const Digits = config.decimalvalues;
    let TokenPriceInStr = (Price * Digits).toString();
    TokenPriceInStr = await convert(TokenPriceInStr);
    TokenPriceInStr = await ChecktokenDecimal(TokenPriceInStr, Digits);
    console.log(ipfs_hash, "ipfs_hashipfs_hashipfs_hashipfs_hash");
    setTimeout(async () => {
      if (
        ipfs_hash &&
        ipfs_hash != null &&
        ipfs_hash != undefined &&
        ipfs_hash != ""
      ) {
        if (CollectiblesType == "Single") {
          await CoursetroContract.methods
            .mint(
              tokeid,
              TokenName,
              ipfs_url,
              ipfs_hash,
              TokenPriceInStr,
              TokenQuantity,
              TokenRoyalities
            )
            .send({ from: currAddr[0].toLowerCase() })
            .then(async (result) => {
              var transactionHash = "";
              if (result.transactionHash) {
                transactionHash = result.transactionHash;
              } else {
                transactionHash = result;
              }
              Set_MintHashVal(transactionHash);
              // setTimeout(() => {
              toast.success("NFT minted successfully", toasterOption);
              var Status = "true";
              var TokenAddItemPayload = {
                Image: TokenFile,
                ipfsimage: ipfs_hash,
                Name: TokenName,
                Count: tokeid,
                Description: TokenDescription,
                Price: Price,
                TokenPrice: TokenPrice,
                Royalities: TokenRoyalities,
                Category_label: TokenCategory,
                Properties: JSON.stringify(values.val),
                Owner: currAddr[0].toLowerCase(),
                Creator: currAddr[0].toLowerCase(),
                CategoryId: TokenCategory,
                Quantity: TokenQuantity,
                Balance: TokenQuantity,
                ContractAddress: selectedcontract,
                Status: Status,
                HashValue: transactionHash,
                Type: 721,
                MinimumBid: 0,
                MaximumBid: 0,
                Clocktime: "",
                EndClocktime: "",
                UnLockcontent: "",
                PutOnSale: PutOnSale,
                PutOnSaleType: PutOnSaleType,
                currencyName: currencyName,
              };
              if (Unlockoncepurchased == true) {
                TokenAddItemPayload.UnLockcontent = UnLockcontent;
              }

              // if(PutOnSale==true) {

              if (!putonmarket) {
                TokenAddItemPayload.Price = 0;
                TokenAddItemPayload.TokenPrice = 0;
                TokenAddItemPayload.MinimumBid = 0;
                TokenAddItemPayload.MaximumBid = 0;
                TokenAddItemPayload.Clocktime = Clocktime;
                TokenAddItemPayload.EndClocktime = EndClocktime;
                TokenAddItemPayload.PutOnSale = false;
                TokenAddItemPayload.PutOnSaleType = "putonmarket";
              } else if (PutOnSaleType == "FixedPrice") {
                TokenAddItemPayload.Price = Price;
                TokenAddItemPayload.TokenPrice = TokenPrice;
              } else if (PutOnSaleType == "TimedAuction") {
                TokenAddItemPayload.MinimumBid = MinimumBid;
                TokenAddItemPayload.MaximumBid = MaximumBid;
                TokenAddItemPayload.Clocktime = Clocktime;
                TokenAddItemPayload.EndClocktime = EndClocktime;
                TokenAddItemPayload.Price = 0;
              } else {
                TokenAddItemPayload.PutOnSaleType = PutOnSaleType;
                TokenAddItemPayload.MinimumBid = MinimumBid;
                TokenAddItemPayload.MaximumBid = MaximumBid;
              }
              // }

              await TokenAddItemAction(TokenAddItemPayload);
              var TokenAddOwnerPayload = {
                Count: tokeid,
                Price: Price,
                TokenPrice: TokenPrice,
                Owner: currAddr[0].toLowerCase(),
                Balance: TokenQuantity,
                Quantity: TokenQuantity,
                ContractAddress: selectedcontract,
                Type: 721,
                HashValue: transactionHash,
                Status: Status,
                currencyName: currencyName,
              };
              if (!putonmarket) {
                TokenAddOwnerPayload.Price = 0;
                TokenAddOwnerPayload.TokenPrice = 0;
                TokenAddItemPayload.MinimumBid = 0;
                TokenAddItemPayload.MaximumBid = 0;
              } else if (PutOnSaleType == "FixedPrice") {
                TokenAddOwnerPayload.Price = Price;
                TokenAddOwnerPayload.TokenPrice = TokenPrice;
              } else if (PutOnSaleType == "TimedAuction") {
                TokenAddItemPayload.MinimumBid = MinimumBid;
                TokenAddItemPayload.MaximumBid = MaximumBid;
              }
              await TokenAddOwnerAction(TokenAddOwnerPayload);
              setMintCallStatus("done");
              if (!putonmarket) {
                setTimeout(
                  () => window.$("#create_item_modal").modal("hide"),
                  600
                );
                setTimeout(() => (window.location.href = "/"), 1200);
              }
              // })
              // }, 1500);
            })
            .catch((error) => {
              toast.error("Mint action rejected by user", toasterOption);
              setMintCallStatus("tryagain");
            });
        } else {
          //var currAddr = window.web3.eth.defaultAccount;
          await CoursetroContract.methods
            .mint(
              tokeid,
              TokenPriceInStr,
              TokenRoyalities,
              TokenQuantity,
              TokenName,
              ipfs_hash,
              ipfs_url
            )
            .send({ from: currAddr[0].toLowerCase() })
            .then(async (result) => {
              var transactionHash = "";
              if (result.transactionHash) {
                transactionHash = result.transactionHash;
              } else {
                transactionHash = result;
              }
              Set_MintHashVal(transactionHash);
              toast.success("NFT minted successfully", toasterOption);
              var Status = "true";
              var TokenAddItemPayload = {
                Image: TokenFile,
                ipfsimage: ipfs_hash,
                Name: TokenName,
                Count: tokeid,
                Description: TokenDescription,
                Price: Price,
                TokenPrice: TokenPrice,
                Royalities: TokenRoyalities,
                Category_label: TokenCategory,
                Properties: JSON.stringify(values.val),
                Owner: currAddr[0].toLowerCase(),
                Creator: currAddr[0].toLowerCase(),
                CategoryId: TokenCategory,
                Quantity: TokenQuantity,
                Balance: TokenQuantity,
                ContractAddress: selectedcontract,
                Status: Status,
                HashValue: transactionHash,
                Type: 1155,
                MinimumBid: 0,
                MaximumBid: 0,
                Clocktime: "",
                EndClocktime: "",
                UnLockcontent: "",
                PutOnSale: PutOnSale,
                PutOnSaleType: PutOnSaleType,
                currencyName: currencyName,
              };
              if (Unlockoncepurchased == true) {
                TokenAddItemPayload.UnLockcontent = UnLockcontent;
              }
              if (collectioncategoryname != "Select") {
                TokenAddItemPayload.collectioncategoryname =
                  collectioncategoryname;
              }
              if (!putonmarket) {
                TokenAddItemPayload.Price = 0;
                TokenAddItemPayload.TokenPrice = 0;
                TokenAddItemPayload.MinimumBid = 0;
                TokenAddItemPayload.MaximumBid = 0;
                TokenAddItemPayload.Clocktime = Clocktime;
                TokenAddItemPayload.EndClocktime = EndClocktime;
                TokenAddItemPayload.PutOnSale = false;
                TokenAddItemPayload.PutOnSaleType = "putonmarket";
              } else if (PutOnSale == true) {
                if (PutOnSaleType == "FixedPrice") {
                  TokenAddItemPayload.Price = Price;
                  TokenAddItemPayload.TokenPrice = TokenPrice;
                } else if (PutOnSaleType == "TimedAuction") {
                  TokenAddItemPayload.MinimumBid = MinimumBid;
                  TokenAddItemPayload.MaximumBid = MaximumBid;
                  TokenAddItemPayload.Clocktime = Clocktime;
                  TokenAddItemPayload.EndClocktime = EndClocktime;
                  TokenAddItemPayload.Price = 0;
                } else {
                  TokenAddItemPayload.MinimumBid = MinimumBid;
                  TokenAddItemPayload.MaximumBid = MaximumBid;
                }
              }
              await TokenAddItemAction(TokenAddItemPayload);
              var TokenAddOwnerPayload = {
                Count: tokeid,
                Price: Price,
                TokenPrice: TokenPrice,
                Owner: currAddr[0].toLowerCase(),
                Balance: TokenQuantity,
                Quantity: TokenQuantity,
                ContractAddress: selectedcontract,
                Type: 1155,
                HashValue: transactionHash,
                Status: Status,
                currencyName: currencyName,
              };
              if (!putonmarket) {
                TokenAddOwnerPayload.Price = 0;
                TokenAddOwnerPayload.TokenPrice = 0;
                TokenAddItemPayload.MinimumBid = 0;
                TokenAddItemPayload.MaximumBid = 0;
              } else if (PutOnSaleType == "FixedPrice") {
                TokenAddOwnerPayload.Price = Price;
                TokenAddOwnerPayload.TokenPrice = TokenPrice;
              }

              await TokenAddOwnerAction(TokenAddOwnerPayload);
              setMintCallStatus("done");
              if (!putonmarket) {
                setTimeout(
                  () => window.$("#create_item_modal").modal("hide"),
                  600
                );
                setTimeout(() => (window.location.href = "/"), 1200);
              }
              // })
              // }, 1500);
            })
            .catch((error) => {
              toast.error("Action rejected by user", toasterOption);
              setMintCallStatus("tryagain");
            });
        }
      } else {
        toast.warning(
          "Error , Please wait few secount and try again",
          toasterOption
        );
        setMintCallStatus("tryagain");
      }
    }, 4000);
  }
  function removeClick(i) {
    let vals = [...values.val];
    vals.splice(i, 1);
    setValues({ val: vals });
  }
  function handleChange(event) {
    let vals = [...values.val];
    vals[this].des = event.target.value;
    setValues({ val: vals });
  }
  function handleunitChange(event) {
    let units = [...values.val];
    units[this].unit = event.target.value;
    setValues({ val: units });
  }
  function createInputs() {
    return values.val.map((el, i) => (
      <div className="row">
        <div className="col-md-5">
          <input
            type="text"
            name="item_royalties"
            id="item_royalties"
            class="form-control"
            placeholder="e.g. Color"
            onChange={handleChange.bind(i)}
            value={el.des}
          />
        </div>
        <div className="col-md-5">
          <input
            type="text"
            name="item_royalties"
            id="item_royalties"
            class="form-control"
            placeholder="e.g. Blue"
            onChange={handleunitChange.bind(i)}
            value={el.unit}
          />
        </div>
        {i != 0 && (
          <div className="col-md-1">
            <i onClick={() => removeClick(i)} class="fas fa-times"></i>
          </div>
        )}
      </div>
    ));
  }
  async function SignCall() {
    // if (!window.ethereum) {
    //   toast.warning("OOPS!..connect Your Wallet", toasterOption);
    // }
    var mydata = await connection();
    const web3 = new Web3(
      mydata &&
      mydata.provider &&
      mydata.provider != null &&
      mydata.provider != undefined &&
      mydata.provider != ""
        ? mydata.provider
        : window.ethereum
    );
    var currAddr = await web3.eth.getAccounts();

    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
    }

    setSignCallStatus("processing");
    web3.eth.personal
      .sign(
        "Sign the sale order to put NFT for Sale",
        currAddr[0].toLowerCase()
      )
      .then(async (result) => {
        toast.success("Signed Successfully", toasterOption);
        setSignCallStatus("done");
        if (!Unlockoncepurchased) {
          setTimeout(() => window.$("#create_item_modal").modal("hide"), 600);
          setTimeout(() => (window.location.href = "/"), 1200);
        }
      })
      .catch(() => {
        toast.error("Signature rejected by user", toasterOption);
        setSignCallStatus("tryagain");
      });
  }

  async function AfterWalletConnected() {
    // GetCategoryCall();
  }

  async function SignLockCall() {
    var mydata = await connection();
    const web3 = new Web3(
      mydata &&
      mydata.provider &&
      mydata.provider != null &&
      mydata.provider != undefined &&
      mydata.provider != ""
        ? mydata.provider
        : window.ethereum
    );
    var currAddr = await web3.eth.getAccounts();

    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
    }

    setSignLockCallStatus("processing");
    web3.eth.personal
      .sign(
        "Sign and authorize the unlockable contents",
        currAddr[0].toLowerCase()
      )
      .then(async (result) => {
        toast.success("Signed Successfully", toasterOption);
        setSignLockCallStatus("done");
        setTimeout(() => window.$("#create_item_modal").modal("hide"), 600);
        setTimeout(() => (window.location.href = "/"), 1200);
      })
      .catch(() => {
        toast.error("Signature rejected by user", toasterOption);
        setSignLockCallStatus("tryagain");
      });
  }
  // Countdown Timer
  const currentDate = new Date();
  const year =
    currentDate.getMonth() === 11 && currentDate.getDate() > 23
      ? currentDate.getFullYear() + 1
      : currentDate.getFullYear();

  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <div className="timer_panel">
        <span>
          <span className="timer_time">{zeroPad(days)}</span>
          <span className="timer_label">d</span>
        </span>
        <span className="timer_dots"> </span>
        <span>
          <span className="timer_time">{zeroPad(hours)}</span>
          <span className="timer_label">h</span>
        </span>
        <span className="timer_dots"> </span>
        <span>
          <span className="timer_time">{zeroPad(minutes)}</span>
          <span className="timer_label">m</span>
        </span>
        <span className="timer_dots"> </span>
        <span>
          <span className="timer_time">{zeroPad(seconds)}</span>
          <span className="timer_label">s</span>
        </span>
      </div>
    );
  };

  var settings = {
    center: false,
    items: 5,
    loop: true,
    margin: 15,
    nav: true,
    navText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>",
    ],
    dots: false,
    responsive: {
      1000: {
        items: 3,
      },
      600: {
        items: 2,
      },
      0: {
        items: 2,
      },
    },
  };
  return (
    <div id="wrapper">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Omnieden NFT - Create</title>
      </Helmet>
      <ScrollToTopOnMount />
      <ConnectWallet
        Set_UserAccountAddr={Set_UserAccountAddr}
        Set_UserAccountBal={Set_UserAccountBal}
        Set_WalletConnected={setWalletConnected}
        Set_AddressUserDetails={Set_AddressUserDetails}
        AddressUserDetails={AddressUserDetails}
        Set_Accounts={Set_Accounts}
        WalletConnected={WalletConnected}
        AfterWalletConnected={AfterWalletConnected}
      />
      <Header />
      <div className="no-bottom no-top" id="content">
        <section
          id="subheader"
          class="text-light"
          data-bgimage="url(images/background/subheader-dark.jpg) top"
        >
          <div class="center-y relative text-center">
            <div class="container">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h1>Create</h1>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </section>

        <section aria-label="section" className="pt30 pb30">
          <div class="container">
            <div class="row wow fadeIn">
              <div class="col-lg-7 offset-lg-1">
                <div className="de_tab tab_simple">
                  <nav>
                    <div
                      className="nav nav-tabs de_nav justify-content-center"
                      id="nav-tab"
                      role="tablist"
                    >
                      <a
                        onClick={() => changeCollectiblesType("Single")}
                        className={
                          CollectiblesType == "Single"
                            ? "nav-item nav-link active"
                            : "nav-item nav-link"
                        }
                        id="nav-onSale-tab"
                        data-toggle="tab"
                        href="#nav-onSale"
                        role="tab"
                        aria-controls="nav-onSale"
                        aria-selected={
                          CollectiblesType == "Single" ? "true" : "false"
                        }
                      >
                        Single
                      </a>
                      <a
                        onClick={() => changeCollectiblesType("Multiple")}
                        className={
                          CollectiblesType == "Multiple"
                            ? "nav-item nav-link active"
                            : "nav-item nav-link"
                        }
                        id="nav-onSale-tab"
                        data-toggle="tab"
                        href="#nav-onSale"
                        role="tab"
                        aria-controls="nav-onSale"
                        aria-selected={
                          CollectiblesType == "Multiple" ? "true" : "false"
                        }
                      >
                        Multiple
                      </a>
                    </div>
                  </nav>
                  <div
                    className="tab-content de_tab_content"
                    id="nav-tabContent"
                  >
                    <div
                      className="tab-pane fade show active"
                      id="nav-onSale"
                      role="tabpanel"
                      aria-labelledby="nav-onSale-tab"
                    >
                      <form
                        id="form-create-item"
                        class="form-border"
                        method="post"
                      >
                        <div class="field-set">
                          <label className="primary_label">Upload file</label>

                          <div class="d-create-file">
                            <p id="file_name">
                              PNG, JPG, JPEG, SVG, GIF, WEBP, MP4, WAV, MP3 .
                              Max 100 MB.{" "}
                              <span className="text-muted">(Required)</span>
                            </p>
                            {ValidateError.TokenFilePreUrl && (
                              <span className="text-danger">
                                {ValidateError.TokenFilePreUrl}
                              </span>
                            )}

                            <div className="uploadCustomFile">
                              <input
                                type="button"
                                id="get_file"
                                class="btn-main"
                                value="Browse"
                              />
                              <input
                                type="file"
                                id="upload_file"
                                onChange={selectFileChange}
                              />
                            </div>
                          </div>

                          <div class="spacer-single"></div>

                          <label className="primary_label">
                            Create collection
                          </label>

                          <div class="de_tab tab_methods createTypeTab">
                            <nav className="mb-4">
                              {showcreate ? (
                                <div
                                  class="nav nav-tabs de_nav createNavTab"
                                  id="nav-tab"
                                  role="tablist"
                                >
                                  <a
                                    class="nav-item nav-link"
                                    data-toggle="modal"
                                    data-target="#choose_collection_modal"
                                  >
                                    <span>
                                      <i class="fas fa-plus"></i>Create
                                    </span>
                                  </a>

                                  <a
                                    onClick={() => {
                                      changeDefaultCollection(
                                        "defaultCollection"
                                      );
                                    }}
                                    class={
                                      "nav-item nav-link " +
                                      (DefaultCollection == "defaultCollection"
                                        ? "active"
                                        : "")
                                    }
                                    id="nav-TimedAuction-tab"
                                    data-toggle="tab"
                                    href="#nav-timedAuction"
                                    role="tab"
                                    aria-controls="nav-timedAuction"
                                    aria-selected={
                                      PutOnSaleType == "TimedAuction"
                                        ? "true"
                                        : "false"
                                    }
                                  >
                                    <span>
                                      <i className="fas fa-folder-open"></i>{" "}
                                      Default Collection
                                    </span>
                                  </a>
                                </div>
                              ) : (
                                <div
                                  class="nav nav-tabs de_nav createNavTab"
                                  id="nav-tab"
                                  role="tablist"
                                >
                                  <a
                                    class="nav-item nav-link"
                                    // data-toggle="modal"
                                    // data-target="#choose_collection_modal"
                                  >
                                    <span>
                                      <i class="fas fa-plus"></i>Select Etherium
                                      Mainnet
                                    </span>
                                  </a>
                                </div>
                              )}
                            </nav>

                            <label className="primary_label">
                              Choose collection{" "}
                              <span className="text-muted">(Required)</span>
                            </label>

                            <Select
                              id="collection"
                              value={selectedOption}
                              onChange={changecollectionCategory}
                              options={collectionlist}
                              styles={colourStyles}
                            />
                            {/* {ValidateError.TokenCategory && (
                              <span className="text-danger">
                                <br />
                                {ValidateError.TokenCategory}
                              </span>
                            )} */}
                          </div>

                          <div className="input_Unlock_section">
                            <div>
                              <label className="primary_label">
                                Put on marketplace
                              </label>
                              <p>Put your new NFT on Omnieden's marketplace</p>
                            </div>
                            <label className="switch1 toggle_custom">
                              <input
                                type="checkbox"
                                id="putonsale"
                                name="putonsale"
                                onChange={CheckedChange}
                                checked={putonmarket}
                              />
                              <span className="slider"></span>
                            </label>
                          </div>

                          <div class="spacer-single"></div>

                          {putonmarket && (
                            <label className="primary_label">
                              Select method
                            </label>
                          )}
                          <div class="de_tab tab_methods createTypeTab">
                            {putonmarket && (
                              <nav className="mb-4">
                                <div
                                  class="nav nav-tabs de_nav createNavTab"
                                  id="nav-tab"
                                  role="tablist"
                                >
                                  <a
                                    onClick={() => {
                                      changePutOnSaleType("FixedPrice");
                                    }}
                                    class={
                                      "nav-item nav-link " +
                                      (PutOnSaleType == "FixedPrice"
                                        ? "active"
                                        : "")
                                    }
                                    id="nav-FixedPrice-tab"
                                    data-toggle="tab"
                                    href="#nav-fixedPrice"
                                    role="tab"
                                    aria-controls="nav-fixedPrice"
                                    aria-selected={
                                      PutOnSaleType == "FixedPrice"
                                        ? "true"
                                        : "false"
                                    }
                                  >
                                    <span>
                                      <i class="fa fa-tag"></i>Fixed price
                                    </span>
                                  </a>
                                  {CollectiblesType == "Single" && (
                                    <a
                                      onClick={() => {
                                        changePutOnSaleType("TimedAuction");
                                      }}
                                      class={
                                        "nav-item nav-link " +
                                        (PutOnSaleType == "TimedAuction"
                                          ? "active"
                                          : "")
                                      }
                                      id="nav-TimedAuction-tab"
                                      data-toggle="tab"
                                      href="#nav-timedAuction"
                                      role="tab"
                                      aria-controls="nav-timedAuction"
                                      aria-selected={
                                        PutOnSaleType == "TimedAuction"
                                          ? "true"
                                          : "false"
                                      }
                                    >
                                      <span>
                                        <i class="fa fa-hourglass-1"></i>Timed
                                        auction
                                      </span>
                                    </a>
                                  )}
                                  <a
                                    onClick={() => {
                                      changePutOnSaleType("UnLimitedAuction");
                                    }}
                                    class={
                                      "nav-item nav-link " +
                                      (PutOnSaleType == "UnLimitedAuction"
                                        ? "active"
                                        : "")
                                    }
                                    id="nav-openForBids-tab"
                                    data-toggle="tab"
                                    href="#nav-openForBids"
                                    role="tab"
                                    aria-controls="nav-openForBids"
                                    aria-selected={
                                      PutOnSaleType == "UnLimitedAuction"
                                        ? "true"
                                        : "false"
                                    }
                                  >
                                    <span>
                                      <i class="fa fa-users"></i>Open for bids
                                    </span>
                                  </a>
                                </div>
                              </nav>
                            )}
                            {putonmarket && (
                              <div class="tab-content" id="nav-tabContent">
                                {PutOnSaleType == "FixedPrice" && (
                                  <div>
                                    <div
                                      class={"tab-pane fade" + "show active"}
                                      id="nav-fixedPrice"
                                      role="tabpanel"
                                      aria-labelledby="nav-home-tab"
                                    >
                                      <div id="tab_opt_1">
                                        <label className="primary_label">
                                          Price*
                                        </label>
                                        <div className="select_in_but">
                                          <input
                                            type="number"
                                            id="Price"
                                            name="Price"
                                            onChange={inputChange}
                                            class="form-control mb-0 bor-0"
                                            placeholder="Enter price for one item"
                                            value={Price}
                                          />
                                          <div>
                                            <div
                                              id="item_category_multiple1"
                                              class="dropdown w-100"
                                            >
                                              <Select
                                                id="collection"
                                                onChange={changeCurrency}
                                                options={bidprice}
                                                styles={colourStyles}
                                                defaultValue={{
                                                  value: config.currencySymbol,
                                                  label: config.currencySymbol,
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {ValidateError.Price && (
                                        <span className="text-danger">
                                          {ValidateError.Price}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {PutOnSaleType == "TimedAuction" && (
                                  <div
                                    class={
                                      "tab-pane fade" +
                                      (PutOnSaleType == "TimedAuction"
                                        ? " show active"
                                        : "")
                                    }
                                    id="nav-timedAuction"
                                    role="tabpanel"
                                    aria-labelledby="nav-profile-tab"
                                  >
                                    <div id="tab_opt_2">
                                      <label className="primary_label">
                                        Minimum bid amount*
                                      </label>
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          ["e", "E", "+", "-", ","].includes(
                                            evt.key
                                          ) && evt.preventDefault()
                                        }
                                        name="MinimumBid"
                                        id="MinimumBid"
                                        autoComplete="off"
                                        onChange={inputChange}
                                        class="form-control"
                                        placeholder="Enter minimum bid amount"
                                      />
                                      {ValidateError.MinimumBid && (
                                        <span className="text-danger">
                                          {ValidateError.MinimumBid}
                                        </span>
                                      )}
                                      <br />
                                      <label className="primary_label">
                                        Maximum bid amount*
                                      </label>
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          ["e", "E", "+", "-", ","].includes(
                                            evt.key
                                          ) && evt.preventDefault()
                                        }
                                        name="MaximumBid"
                                        id="MaximumBid"
                                        autoComplete="off"
                                        onChange={inputChange}
                                        class="form-control"
                                        placeholder="Enter maximum bid amount"
                                      />
                                      {ValidateError.MaximumBid && (
                                        <span className="text-danger">
                                          {ValidateError.MaximumBid}
                                        </span>
                                      )}

                                      <div class="spacer-10"></div>

                                      <div class="row">
                                        <div class="col-md-6">
                                          <div className="drobdown_section">
                                            <label className="primary_label">
                                              Starting date
                                            </label>
                                            <div class="dropdown">
                                              <button
                                                class="btn btn-secondary dropdown-toggle filter_btn inp_btn m-0 text-left w-100"
                                                type="button"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                              >
                                                <span id="menuBut">
                                                  {StartDate}
                                                </span>
                                              </button>
                                              <div
                                                class="dropdown-menu filter_menu"
                                                aria-labelledby="dropdownMenuButton"
                                              >
                                                <div
                                                  id="RightAfterListing"
                                                  onClick={() => {
                                                    DateChange(
                                                      "StartDateDropDown",
                                                      "RightAfterListing"
                                                    );
                                                  }}
                                                >
                                                  Right after listing
                                                </div>
                                                <div
                                                  id="PickStart"
                                                  onClick={() => {
                                                    DateChange(
                                                      "StartDateDropDown",
                                                      "PickStartDate"
                                                    );
                                                  }}
                                                >
                                                  Pick specific date
                                                </div>
                                              </div>
                                              {ValidateError.StartDate && (
                                                <span className="text-danger">
                                                  {ValidateError.StartDate}
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                          {/* <input type="date" name="bid_starting_date" id="bid_starting_date" class="form-control" onChange={(date:Date) => setStartDate(date)} min="1997-01-01" /> */}
                                        </div>

                                        <div class="col-md-6">
                                          <div className="drobdown_section">
                                            <label className="primary_label">
                                              Expiration date
                                            </label>
                                            <div class="dropdown">
                                              <button
                                                class="btn btn-secondary dropdown-toggle filter_btn inp_btn m-0 text-left w-100"
                                                type="button"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                              >
                                                <span id="menuBut">
                                                  {EndDate}
                                                </span>
                                              </button>
                                              <div
                                                class="dropdown-menu filter_menu"
                                                aria-labelledby="dropdownMenuButton"
                                              >
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "1 Day"
                                                    );
                                                  }}
                                                >
                                                  1 Day
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "3 Day"
                                                    );
                                                  }}
                                                >
                                                  3 Day
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "5 Day"
                                                    );
                                                  }}
                                                >
                                                  5 Day
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "7 Day"
                                                    );
                                                  }}
                                                >
                                                  7 Day
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "PickEndDate"
                                                    );
                                                  }}
                                                >
                                                  Pick specific date
                                                </div>
                                              </div>
                                              {ValidateError.EndDate && (
                                                <span className="text-danger">
                                                  {ValidateError.EndDate}
                                                </span>
                                              )}
                                            </div>
                                          </div>

                                          {/* <input type="date" name="bid_expiration_date" id="bid_expiration_date" class="form-control" /> */}
                                        </div>

                                        <div class="spacer-single"></div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {/* {PutOnSaleType == "UnLimitedAuction" && (
                                  <div
                                    class={
                                      "tab-pane fade" +
                                      (PutOnSaleType == "UnLimitedAuction"
                                        ? " show active"
                                        : "")
                                    }
                                    id="nav-openForBids"
                                    role="tabpanel"
                                    aria-labelledby="nav-contact-tab"
                                  >
                                    <div id="tab_opt_2">
                                      <label className="primary_label">
                                        Minimum bid amount
                                      </label>
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          ["e", "E", "+", "-", ","].includes(
                                            evt.key
                                          ) && evt.preventDefault()
                                        }
                                        name="MinimumBid"
                                        id="MinimumBid"
                                        autoComplete="off"
                                        onChange={inputChange}
                                        class="form-control"
                                        placeholder="Enter minimum bid amount"
                                      />
                                      {ValidateError.MinimumBid && (
                                        <span className="text-danger">
                                          <br />
                                          {ValidateError.MinimumBid}
                                        </span>
                                      )}

                                      <label className="primary_label">
                                        Maximum bid amount
                                      </label>
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          ["e", "E", "+", "-", ","].includes(
                                            evt.key
                                          ) && evt.preventDefault()
                                        }
                                        name="MaximumBid"
                                        id="MaximumBid"
                                        autoComplete="off"
                                        onChange={inputChange}
                                        class="form-control"
                                        placeholder="Enter maximum bid amount"
                                      />
                                      {ValidateError.MaximumBid && (
                                        <span className="text-danger">
                                          <br />
                                          {ValidateError.MaximumBid}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )} */}
                              </div>
                            )}
                            <label className="primary_label">
                              Title{" "}
                              <span className="text-muted">(Required)</span>
                            </label>
                            <input
                              type="text"
                              name="TokenName"
                              id="TokenName"
                              onChange={inputChange}
                              autoComplete="off"
                              class="form-control"
                              placeholder="Name your NFT"
                            />
                            {ValidateError.TokenName && (
                              <span className="text-danger">
                                {ValidateError.TokenName}
                              </span>
                            )}
                            <br />
                            <label className="primary_label">
                              Description{" "}
                              <span className="text-muted">(Optional)</span>
                            </label>
                            <textarea
                              data-autoresize
                              name="TokenDescription"
                              id="TokenDescription"
                              autoComplete="off"
                              onChange={inputChange}
                              class="form-control"
                              placeholder="Write some fascinating story about your NFT"
                              rows="2"
                            ></textarea>
                            {ValidateError.TokenDescription && (
                              <span className="text-danger">
                                {ValidateError.TokenDescription}
                              </span>
                            )}
                            <label className="primary_label">
                              Royalty{" "}
                              <span className="text-muted">(Required)</span>
                            </label>
                            <input
                              type="number"
                              name="TokenRoyalities"
                              id="TokenRoyalities"
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-", ".", ","].includes(
                                  evt.key
                                ) && evt.preventDefault()
                              }
                              onChange={inputChange}
                              autoComplete="off"
                              class="form-control"
                              placeholder="Suggested: 5% (Max 40%)"
                              max="40"
                              min="5"
                              value={TokenRoyalities}
                            />
                            {ValidateError.TokenRoyalities && (
                              <span className="text-danger">
                                {ValidateError.TokenRoyalities}
                              </span>
                            )}
                            <div class="spacer-10"></div>
                            <label className="primary_label">
                              Category{" "}
                              <span className="text-muted">(Required)</span>
                            </label>
                            <div id="item_category" class="dropdown w-100">
                              <Select
                                id="category"
                                onChange={changeCategory}
                                options={CategoryOption}
                                styles={colourStyles}
                              />

                              {ValidateError.TokenCategory && (
                                <span className="text-danger">
                                  {ValidateError.TokenCategory}
                                </span>
                              )}
                            </div>
                            <div class="spacer-10"></div>

                            <label className="primary_label">
                              Properties{" "}
                              <span className="text-muted">(Optional)</span>
                            </label>
                            {createInputs()}

                            <button
                              className="btn-main"
                              type="button"
                              onClick={addClick}
                            >
                              Add Properties
                            </button>

                            <div class="spacer-10"></div>
                            <div className="input_Unlock_section">
                              <div>
                                <label className="primary_label">
                                  Unlockable content
                                </label>
                                <p>
                                  The content is visible only to the current
                                  owner.
                                </p>
                              </div>
                              <label className="switch1 toggle_custom">
                                <input
                                  type="checkbox"
                                  id="unlockoncepurchased"
                                  name="unlockoncepurchased"
                                  onChange={CheckedChange}
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                            {Unlockoncepurchased && (
                              <div className="unlock_show">
                                <label className="primary_label">
                                  Enter unlockable content
                                </label>
                                <textarea
                                  className="form-control primary_inp"
                                  name="UnLockcontent"
                                  id="UnLockcontent"
                                  onChange={inputChange}
                                  placeholder="Enter unlockable content. E.g. Link, password or instructions etc."
                                  rows="2"
                                ></textarea>
                                {ValidateError.UnLockcontent && (
                                  <span className="text-danger">
                                    {ValidateError.UnLockcontent}
                                  </span>
                                )}
                              </div>
                            )}

                            <div class="spacer-10"></div>
                            {CollectiblesType == "Multiple" && (
                              <div>
                                <label className="primary_label">
                                  Number of copies
                                </label>
                                <input
                                  type="number"
                                  onChange={
                                    CollectiblesType == "Single"
                                      ? ""
                                      : inputChange
                                  }
                                  value={TokenQuantity}
                                  onKeyDown={(evt) =>
                                    ["e", "E", "+", "-", "."].includes(
                                      evt.key
                                    ) && evt.preventDefault()
                                  }
                                  name="TokenQuantity"
                                  id="TokenQuantity"
                                  class="form-control"
                                  placeholder="e.g. 1 or 2 or 3"
                                />
                                {ValidateError.TokenQuantity && (
                                  <span className="text-danger">
                                    <br />
                                    {ValidateError.TokenQuantity}
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="nav-owned"
                      role="tabpanel"
                      aria-labelledby="nav-owned-tab"
                    >
                      <form
                        id="form-create-item"
                        class="form-border"
                        method="post"
                        action="email.php"
                      >
                        <div class="field-set">
                          <label className="primary_label">Upload file</label>

                          <div class="d-create-file">
                            <p id="file_name">
                              PNG, JPG, GIF, WEBP or MP4. Max 200mb.
                            </p>
                            <div className="uploadCustomFile">
                              <input
                                type="button"
                                id="get_file"
                                class="btn-main"
                                value="Browse"
                              />
                              <input type="file" id="upload_file" />
                            </div>
                          </div>

                          <div class="spacer-single"></div>

                          <label className="primary_label">
                            Choose Collections{" "}
                          </label>
                          <div class="de_tab tab_methods">
                            <nav className="mb-4">
                              <div
                                class="nav nav-tabs de_nav createNavTab"
                                id="nav-tab"
                                role="tablist"
                              >
                                <a
                                  class="nav-item nav-link active"
                                  id="nav-fixedPrice-tab"
                                  data-toggle="tab"
                                  href="#nav-fixedPrice"
                                  role="tab"
                                  aria-controls="nav-fixedPrice"
                                  aria-selected="true"
                                >
                                  <span>
                                    <i class="fa fa-tag"></i>Fixed price
                                  </span>
                                </a>
                              </div>
                            </nav>
                          </div>

                          <div class="spacer-single"></div>

                          {putonmarket && (
                            <label className="primary_label">
                              Select method
                            </label>
                          )}
                          <div class="de_tab tab_methods">
                            {putonmarket && (
                              <nav className="mb-4">
                                <div
                                  class="nav nav-tabs de_nav createNavTab"
                                  id="nav-tab"
                                  role="tablist"
                                >
                                  <a
                                    class="nav-item nav-link active"
                                    id="nav-fixedPrice-tab"
                                    data-toggle="tab"
                                    href="#nav-fixedPrice"
                                    role="tab"
                                    aria-controls="nav-fixedPrice"
                                    aria-selected="true"
                                  >
                                    <span>
                                      <i class="fa fa-tag"></i>Fixed price
                                    </span>
                                  </a>
                                  <a
                                    class="nav-item nav-link"
                                    id="nav-timedAuction-tab"
                                    data-toggle="tab"
                                    href="#nav-timedAuction"
                                    role="tab"
                                    aria-controls="nav-timedAuction"
                                    aria-selected="false"
                                  >
                                    <span>
                                      <i class="fa fa-hourglass-1"></i>Timed
                                      auction
                                    </span>
                                  </a>
                                  <a
                                    class="nav-item nav-link"
                                    id="nav-openForBids-tab"
                                    data-toggle="tab"
                                    href="#nav-openForBids"
                                    role="tab"
                                    aria-controls="nav-openForBids"
                                    aria-selected="false"
                                  >
                                    <span>
                                      <i class="fa fa-users"></i>Open for bids
                                    </span>
                                  </a>
                                </div>
                              </nav>
                            )}

                            {putonmarket && (
                              <div class="tab-content" id="nav-tabContent">
                                <div
                                  class="tab-pane fade show active"
                                  id="nav-fixedPrice"
                                  role="tabpanel"
                                  aria-labelledby="nav-home-tab"
                                >
                                  <div id="tab_opt_1">
                                    <label className="primary_label">
                                      Price
                                    </label>
                                    <input
                                      type="text"
                                      name="item_price"
                                      id="item_price"
                                      class="form-control"
                                      placeholder="enter price for one item (BNB)"
                                      value={Price}
                                    />
                                  </div>
                                </div>
                                <div
                                  class="tab-pane fade"
                                  id="nav-timedAuction"
                                  role="tabpanel"
                                  aria-labelledby="nav-profile-tab"
                                >
                                  <div id="tab_opt_2">
                                    <label className="primary_label">
                                      Minimum bid amount
                                    </label>
                                    <input
                                      type="text"
                                      name="item_price_bid"
                                      id="item_price_bid"
                                      class="form-control"
                                      placeholder="enter minimum bid amount"
                                    />

                                    <div class="spacer-10"></div>

                                    <div class="row">
                                      <div class="col-md-6">
                                        <label className="primary_label">
                                          Starting date
                                        </label>
                                        <input
                                          type="date"
                                          name="bid_starting_date"
                                          id="bid_starting_date"
                                          class="form-control"
                                          min="1997-01-01"
                                        />
                                      </div>
                                      <div class="col-md-6">
                                        <label className="primary_label">
                                          Expiration date
                                        </label>
                                        <input
                                          type="date"
                                          name="bid_expiration_date"
                                          id="bid_expiration_date"
                                          class="form-control"
                                        />
                                      </div>
                                      <div class="spacer-single"></div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="tab-pane fade"
                                  id="nav-openForBids"
                                  role="tabpanel"
                                  aria-labelledby="nav-contact-tab"
                                ></div>
                              </div>
                            )}
                            <label className="primary_label">Title</label>
                            <input
                              type="text"
                              name="item_title"
                              id="item_title"
                              class="form-control"
                              placeholder="e.g. 'Name your NFT'"
                            />

                            <div class="spacer-10"></div>
                            <label className="primary_label">Royalty</label>
                            <input
                              type="text"
                              name="item_royalties"
                              id="item_royalties"
                              class="form-control"
                              placeholder="Suggested: 5% (Max 40%)"
                            />
                            <div class="spacer-10"></div>
                            <label className="primary_label">Category</label>
                            <div
                              id="item_category_multiple"
                              class="dropdown w-100"
                            >
                              <a
                                href="javascript:void(0)"
                                class="btn-selector w-100 d-block"
                              >
                                All categories
                              </a>
                              <ul className="w-100">
                                <li class="active">
                                  <span>All categories</span>
                                </li>
                                <li>
                                  <span>Art</span>
                                </li>
                                <li>
                                  <span>Music</span>
                                </li>
                                <li>
                                  <span>Domain Names</span>
                                </li>
                                <li>
                                  <span>Virtual World</span>
                                </li>
                                <li>
                                  <span>Trading Cards</span>
                                </li>
                                <li>
                                  <span>Collectibles</span>
                                </li>
                                <li>
                                  <span>Sports</span>
                                </li>
                                <li>
                                  <span>Utility</span>
                                </li>
                                <li>
                                  <span>Photography</span>
                                </li>
                                <li>
                                  <span>DeFi</span>
                                </li>
                                <li>
                                  <span>Metaverse</span>
                                </li>
                                <li>
                                  <span>Games</span>
                                </li>
                                <li>
                                  <span>Videos</span>
                                </li>
                              </ul>
                            </div>

                            <div class="spacer-10"></div>
                            <label className="primary_label">Description</label>
                            <textarea
                              data-autoresize
                              name="item_desc"
                              id="item_desc"
                              class="form-control"
                              placeholder="e.g.  Write some fascinating story about your NFT"
                            ></textarea>

                            <div class="spacer-10"></div>

                            <label className="primary_label">
                              Properties <small>(Optional)</small>
                            </label>
                            <input
                              type="text"
                              name="item_royalties"
                              id="item_royalties"
                              class="form-control"
                              placeholder="e.g. size: Small, Medium & Large"
                            />

                            <div class="spacer-single"></div>

                            <div class="spacer-single"></div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-xs-12">
                <div className="createPreview">
                  <label className="primary_label">Preview item</label>
                  <div class="nft__item">
                    <div className="authorLikeTop">
                      <div class="author_list_pp">
                        <a href="#">
                          <img class="lazy" src={profileimage} alt="" />
                          {profilestatus && <i class="fa fa-check"></i>}
                        </a>
                      </div>
                    </div>
                    <div class="nft__item_wrap">
                      {PutOnSaleType == "TimedAuction" && (
                        <div class="de_countdown">
                          <Countdown
                            date={`${year}-02-28T12:00:00`}
                            renderer={renderer}
                          />
                        </div>
                      )}
                      <a href="#">
                        {TokenFilePreUrl.split(".").pop() == "mp4" ? (
                          <video
                            src={
                              TokenFilePreReader != ""
                                ? TokenFilePreReader
                                : `${config.Back_URL}images/previewThumb1.png`
                            }
                            type="video/mp4"
                            id="get_file_2"
                            class="lazy nft__item_preview"
                            alt=""
                            autoPlay
                            playsInLine
                            loop
                            muted
                          ></video>
                        ) : (
                          <div className="text-center">
                            {TokenFilePreUrl.split(".").pop() == "mp3" ||
                            TokenFilePreUrl.split(".").pop() == "wav" ? (
                              <div>
                                <img
                                  src={config.Back_URL + "images/music.png"}
                                  id="get_file_2"
                                  class="lazy nft__item_preview"
                                  alt=""
                                />
                                <audio
                                  src={
                                    TokenFilePreReader != ""
                                      ? TokenFilePreReader
                                      : `${config.Back_URL}images/previewThumb1.png`
                                  }
                                  type="audio/mp3"
                                  controls
                                  controlsList="nodownload"
                                  className="audio home"
                                ></audio>
                              </div>
                            ) : (
                              <img
                                src={
                                  TokenFilePreReader != ""
                                    ? TokenFilePreReader
                                    : `${config.Back_URL}images/previewThumb1.png`
                                }
                                id="get_file_2"
                                class="lazy nft__item_preview"
                                alt=""
                              />
                            )}
                          </div>
                        )}
                      </a>
                    </div>

                    <div class="nft__item_info">
                      <a href="#">
                        <h4>{TokenName}</h4>
                      </a>
                      {PutOnSaleType == "FixedPrice" && putonmarket && (
                        <div class="nft__item_price">
                          {Price} {currencyName}
                          {TokenQuantity != "" && (
                            <span>
                              {TokenQuantity} / {TokenQuantity}
                            </span>
                          )}
                        </div>
                      )}
                      {PutOnSaleType == "TimedAuction" && putonmarket && (
                        <div class="nft__item_price">
                          {MinimumBid} {"WBNB"}
                          {TokenQuantity != "" && (
                            <span>
                              {TokenQuantity} / {TokenQuantity}
                            </span>
                          )}
                        </div>
                      )}
                      <div className="nft-item-group">
                        {PutOnSaleType == "FixedPrice" &&
                          putonmarket &&
                          TokenPrice > 0 && (
                            <div class="nft__item_action">
                              <a href="#" className="btn" type="button">
                                <strong>Place a bid</strong>
                                <div id="container-stars">
                                  <div id="stars"></div>
                                </div>

                                <div id="glow">
                                  <div className="circle"></div>
                                  <div className="circle"></div>
                                </div>
                              </a>
                            </div>
                          )}
                        {PutOnSaleType == "TimedAuction" && putonmarket && (
                          <div class="nft__item_action">
                            <a href="#" className="btn" type="button">
                              <strong>Min bid amount</strong>
                              <div id="container-stars">
                                <div id="stars"></div>
                              </div>

                              <div id="glow">
                                <div className="circle"></div>
                                <div className="circle"></div>
                              </div>
                            </a>
                          </div>
                        )}
                        {PutOnSaleType == "UnLimitedAuction" && putonmarket && (
                          <div class="nft__item_action">
                            <a href="#" className="btn" type="button">
                              <strong>Open for bids</strong>
                              <div id="container-stars">
                                <div id="stars"></div>
                              </div>

                              <div id="glow">
                                <div className="circle"></div>
                                <div className="circle"></div>
                              </div>
                            </a>
                          </div>
                        )}
                        {/* <div class="nft__item_like">
                          <i class="fa fa-heart"></i>
                          <span>0</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showcreate ? (
                <div class="col-lg-11 offset-lg-1">
                  <input
                    type="button"
                    id="submit"
                    class="btn-main"
                    value="Create Item"
                    onClick={CreateItem}
                  />
                </div>
              ) : (
                <div class="col-lg-11 offset-lg-1">
                  <input
                    type="button"
                    id="submit"
                    disabled={true}
                    style={{ background: "#4e4e4e" }}
                    class="btn-main"
                    value="Select Etherium Mainnet "
                    // onClick={CreateItem}
                  />
                </div>
              )}
            </div>
          </div>
        </section>

        <Footer />

        {/*create model */}
        <div
          className="modal fade primary_modal"
          id="create_item_modal"
          data-backdrop="static"
          tabindex="-1"
          role="dialog"
          aria-labelledby="place_bid_modalCenteredLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
                <h5 className="modal-title" id="place_bid_modalLabel">
                  Follow Steps
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form className="px-4 bid_form form-border">
                  {!userApproved && (
                    <div class="media approve_media">
                      {ApproveCallStatus == "processing" ? (
                        <i
                          class="fa fa-spinner fa-spin me-2 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      ) : ApproveCallStatus == "done" ? (
                        <i
                          className="fas fa-check me-2 pro_complete"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <i className="fas fa-check me-2" aria-hidden="true"></i>
                      )}

                      <div class="media-body">
                        <p className="buy_desc_sm">Authorize</p>
                        <p className="buy_desc_sm_bold">
                          Authorize your wallet to perform the transaction
                        </p>
                      </div>
                    </div>
                  )}
                  {!userApproved && (
                    <div className="text-center my-3">
                      <button
                        type="button"
                        onClick={ApproveCall}
                        disabled={
                          ApproveCallStatus == "processing" ||
                          ApproveCallStatus == "done"
                        }
                        className={
                          ApproveCallStatus == "processing" ||
                          ApproveCallStatus == "init"
                            ? "btn-main lead  mar-top-10"
                            : "btn-main btnGrey lead  mar-top-10"
                        }
                      >
                        {ApproveCallStatus == "init" && "Authorize"}
                        {ApproveCallStatus == "processing" && "In-progress..."}
                        {ApproveCallStatus == "done" && "Done"}
                        {ApproveCallStatus == "tryagain" && "Try Again"}
                      </button>
                    </div>
                  )}
                  <div class="media approve_media">
                    {MintCallStatus == "processing" ? (
                      <i
                        class="fa fa-spinner fa-spin me-2 spinner_icon"
                        aria-hidden="true"
                        id="circle1"
                      ></i>
                    ) : MintCallStatus == "done" ? (
                      <i
                        className="fas fa-check me-2 pro_complete"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i className="fas fa-check me-2" aria-hidden="true"></i>
                    )}
                    <div class="media-body">
                      <p className="buy_desc_sm">Upload and Mint NFT</p>
                      <p className="buy_desc_sm_bold">
                        Upload your file and mint the NFT
                      </p>
                    </div>
                  </div>
                  <div className="text-center my-3">
                    <button
                      type="button"
                      disabled={
                        ApproveCallStatus != "done" ||
                        MintCallStatus == "processing" ||
                        MintCallStatus == "done"
                      }
                      onClick={MintCall}
                      className={
                        ApproveCallStatus == "done" && MintCallStatus != "done"
                          ? "btn-main lead  mar-top-10"
                          : "btn-main btnGrey lead  mar-top-10"
                      }
                    >
                      {MintCallStatus == "init" && "Mint"}
                      {MintCallStatus == "processing" && "In-progress..."}
                      {MintCallStatus == "done" && "Done"}
                      {MintCallStatus == "tryagain" && "Try Again"}
                    </button>
                  </div>
                  {putonmarket && (
                    <div class="media approve_media">
                      {SignCallStatus == "processing" ? (
                        <i
                          class="fa fa-spinner fa-spin me-2 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      ) : SignCallStatus == "done" ? (
                        <i
                          className="fas fa-check me-2 pro_complete"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <i className="fas fa-check me-2" aria-hidden="true"></i>
                      )}
                      <div class="media-body">
                        <p className="buy_desc_sm">Sign Sale Order</p>
                        <p className="buy_desc_sm_bold">
                          Sign the sale order to put NFT for Sale.
                        </p>
                      </div>
                    </div>
                  )}
                  {putonmarket && (
                    <div className="text-center my-3">
                      <button
                        type="button"
                        disabled={
                          MintCallStatus != "done" ||
                          SignCallStatus == "processing" ||
                          SignCallStatus == "done"
                        }
                        onClick={SignCall}
                        className={
                          MintCallStatus == "done" && SignCallStatus != "done"
                            ? "btn-main lead  mar-top-10"
                            : "btn-main btnGrey lead  mar-top-10"
                        }
                      >
                        {SignCallStatus == "init" && "Sign"}
                        {SignCallStatus == "processing" && "In-progress..."}
                        {SignCallStatus == "done" && "Done"}
                        {SignCallStatus == "tryagain" && "Try Again"}
                      </button>
                    </div>
                  )}
                  {putonmarket && Unlockoncepurchased && (
                    <div class="media approve_media">
                      {SignLockCallStatus == "processing" ? (
                        <i
                          class="fa fa-spinner fa-spin me-2 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      ) : SignLockCallStatus == "done" ? (
                        <i
                          className="fas fa-check me-2 pro_complete"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <i className="fas fa-check me-2" aria-hidden="true"></i>
                      )}
                      <div class="media-body">
                        <p className="buy_desc_sm">Sign Unlockable Content</p>
                        <p className="buy_desc_sm_bold">
                          Please provide a signature for unlockable content
                        </p>
                      </div>
                    </div>
                  )}
                  {putonmarket && Unlockoncepurchased && (
                    <div className="text-center mt-3">
                      <button
                        type="button"
                        disabled={
                          SignCallStatus != "done" ||
                          SignLockCallStatus == "processing" ||
                          SignLockCallStatus == "done"
                        }
                        onClick={SignLockCall}
                        className={
                          SignCallStatus == "done" &&
                          SignLockCallStatus != "done"
                            ? "btn-main lead  mar-top-10"
                            : "btn-main btnGrey lead  mar-top-10"
                        }
                      >
                        {SignLockCallStatus == "init" && "Lock"}
                        {SignLockCallStatus == "processing" && "In-progress..."}
                        {SignLockCallStatus == "done" && "Done"}
                        {SignLockCallStatus == "tryagain" && "Try Again"}
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* date model */}
        <div
          class="modal fade primary_modal"
          id="calendar_modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="calendar_modalCenteredLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered modal-sm"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-module">
                <div class="modal-header text-center">
                  <h5 class="modal-title" id="calendar_modalLabel">
                    Choose date
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    id="cancelcalender"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div className="pb-3">
                    <Datetime
                      minDate={new Date().getTime()}
                      input={false}
                      value={Clocktime}
                      onChange={(value) => set_Clocktime(value)}
                    />
                  </div>
                </div>
                <div class="text-center mb-3">
                  <input
                    type="submit"
                    name="Done"
                    value="Done"
                    className="primary_btn"
                    id="doneStartDate"
                    onClick={() => ModalAction("calendar_modal", "hide")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade primary_modal"
          id="calendar_modal_expire"
          tabindex="-1"
          role="dialog"
          aria-labelledby="calendar_modalCenteredLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered modal-sm"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-module">
                <div class="modal-header text-center">
                  <h5 class="modal-title" id="calendar_modalLabel">
                    Choose date
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    id="cancelcalender"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div className="pb-3">
                    <Datetime
                      input={false}
                      value={EndClocktime}
                      minDate={new Date().getTime()}
                      onChange={(value) => set_EndClocktime(value)}
                    />
                  </div>
                </div>
                <div class="text-center mb-3">
                  <input
                    type="submit"
                    name="Done"
                    value="Done"
                    className="primary_btn"
                    id="doneEndDate"
                    onClick={() => ModalAction("calendar_modal_expire", "hide")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade primary_modal"
          id="choose_collection_modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="choose_collection_modalCenteredLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header text-center">
                <h5 class="modal-title" id="choose_collection_modalLabel">
                  Collection
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div className="d-flex align-items-center">
                  <div class="hex center">
                    <img
                      src={
                        userimage && userimage != ""
                          ? userimage
                          : require("../assets/images/thumbnail-5.jpg")
                      }
                      alt="logo"
                      className="img-fluid"
                    />
                  </div>
                  <div>
                    <p className="font_16 font_600 line_20 mb-1">
                      We recommend an image of at least 400x400. Gifs work too.
                    </p>
                    <div className="file_btn primary_btn d-inline-block">
                      Choose file
                      <input
                        className="inp_file"
                        type="file"
                        name="file"
                        accept="image/*"
                        id="collectionpic"
                        required="true"
                        onChange={handleFilecollection}
                      />
                    </div>
                  </div>
                </div>
                <form class="form-border" autoComplete="off">
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="name">
                        Collection Name{" "}
                        <span className="text-muted">(Max. 30 characters)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control primary_inp"
                        id="name"
                        placeholder="Enter token name"
                        name="owncollectionname"
                        onChange={inputChangename}
                        value={owncollectionname}
                        maxLength="30"
                      />
                    </div>
                    {collectionvalidate.collectionname && (
                      <span className="text-danger">
                        {collectionvalidate.collectionname}
                      </span>
                    )}
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="desccription">
                        Symbol <span className="text-muted">(Required)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control primary_inp"
                        id="desccription"
                        placeholder="Enter token symbol"
                        name="owncollectionsymbol"
                        onChange={inputChangesymbol}
                        value={owncollectionsymbol}
                      />
                    </div>
                    {collectionvalidate.collectionsymbol && (
                      <span className="text-danger">
                        {collectionvalidate.collectionsymbol}
                      </span>
                    )}
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="name">
                        Description{" "}
                        <span className="text-muted">(Optional)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control primary_inp"
                        id="name"
                        placeholder="Tell us something about this collection"
                        onChange={inputChangedescription}
                        value={collectiondescription}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="desccription">
                        Short url <span className="text-muted">(Required)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control primary_inp"
                        id="desccription"
                        defaultValue={`${config.Front_URL}/collections/`}
                        onChange={inputChangeurl}
                        value={collectionurl}
                        maxLength="100"
                      />
                    </div>
                  </div>
                  {collectionvalidate.url && (
                    <span className="text-danger">
                      {collectionvalidate.url}
                    </span>
                  )}
                  <div className="text-center">
                    <button
                      type="button"
                      className="create_btn"
                      onClick={handleFormSubmit}
                      disabled={showloadercollect}
                    >
                      {showloadercollect == true && (
                        <i
                          class="fa fa-spinner fa-spin me-2 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      )}
                      Create collection
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
